import React from "react";
import {
    Container,
    Row, 
    Form, 
    Button
} from "react-bootstrap";
import ReactGA from 'react-ga';
export default function Referrals (){
    ReactGA.pageview(window.location.pathname + window.location.search);    
    return (

        <Container className='mt-5 mb-5'>
            <h1 className='text-center'>Give 150 AED, get 150 AED.</h1>
        <Row className='mt-5 mb-5 text-center' xs={1} md={1} lg={1} > 
            <h3>Enter your email below to retrieve your referral link, or create a new account.</h3>
            <Form>
            <Form.Group controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter email" />
                <Form.Text className="text-muted">
                We'll never share your email with anyone else.
                </Form.Text>
            </Form.Group>
            <Button variant="primary" type="submit">
                Submit
            </Button>
            </Form>
        </Row>
        </Container>
    )
}


